module.exports = __webpack_public_path__ + "img/ems03.527cce29.png";